<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7cQovG/tc-custom/FC-9781528987509.jpg?1684514917907?1709061530331" alt="This image is the cover for the book Ghosts of the Past"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ghosts of the Past
      </h1>
      <p class="bookDescription body article font2">
        <p>Caroline Kingfisher has questions. Questions she’s been asking all her life which everyone so far has failed to answer. Now of age, and after her parents’ deaths, she sets out on a journey like no other to her old family home to find the answers that have been hidden from her for so long. The more she delves into the past, with only a diary found by chance to guide her, Caroline starts to wonder if some things are better left undiscovered. Travis Montgomery has a secret. He knows something he should never have found out and it’s slowly eating away at him. He can’t confess to his mother, or his brother, and struggles daily with his internal battle. When he spies a new owner arriving at the abandoned mansion house, potentially dangerous events start unfolding that he can’t help but feel somewhat responsible for. As the plot thickens and the dangers increase, will Caroline get the answers she’s so desperate to find? And by helping her, will Travis finally free himself from the guilt he’s been feeling since his childhood?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Laura Johnson
      </h2>
      
      <p class="authorDescription body article">Laura lives in Lancashire with her two cats. As a child, she never enjoyed reading but could just about stomach Roald Dahl. Her passion for fiction grew during her teens, focusing on easy reading, horror stories and after finding a couple more brilliant authors in her twenties, she now can’t put a good book down. Her inspiration for writing has been sparked purely because of past readings. She starts typing and soon, an idea is turned into a story. She’s never sure how it will all end until she can’t think of anything else to type, then she knows it’s finished.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?37cfece2